export default "__VITE_ASSET__dirPQk7J__"